// extracted by mini-css-extract-plugin
var _1 = "AnnualPlanCard_planDisclaimer__OGYFD";
var _2 = "AnnualPlanCard_planSubTitle__Vk5IP";
export { _1 as "planDisclaimer", _2 as "planSubTitle" }
